import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import BaseLayout from 'bento-ordering/base/layouts/Layout';
import { useTheme } from '@material-ui/styles';
import DarkCover from 'bento-ordering/menus/ui_components/DarkCover';

import { getAllLocationsAvailableFulfillmentMethodSelector } from 'bento-ordering/locations/selectors';
import LocationListHeroContent from 'bento-ordering/locations/components/LocationListHeroContent';
import {
  fulfillmentOptions,
  ALL_FULFILLMENT_METHODS
} from 'bento-ordering/cart/constants/fulfillmentOptions';
import { handleAddressSelectLocationList } from 'bento-ordering/locations/actions/locations';
import { getDeliverableLocations } from 'bento-ordering/locations/actions/dinerAddressDeliverable';
import { getAddressStringFromCart } from 'bento-ordering/base/utils/addressHelpers';
import isDineInApplicationVariant from 'bento-ordering/utils/isDineInApplicationVariant';
const LocationListOuterLayout = ({
  children,
  heroImageSrc,
  heroImageAlt,
  availableFulfillmentMethods,
  dispatch,
  googleLoaded,
  cart
}) => {
  const isDineInVariant = isDineInApplicationVariant();
  const handleAddressSelect = (addressComponents, selectedLongLat, placeId) => {
    dispatch(handleAddressSelectLocationList(addressComponents, placeId));
  };
  const getHeroHeader = availableFulfillmentMethods => {
    const base = 'Order for';

    if (isDineInVariant) {
      return `${base} dine-in`;
    }

    if (
      availableFulfillmentMethods.includes(fulfillmentOptions.PICKUP) &&
      availableFulfillmentMethods.includes(fulfillmentOptions.DELIVERY)
    ) {
      return `${base} delivery or pickup`;
    }

    return `${base} ${availableFulfillmentMethods[0]}`;
  };
  const heroHeader = getHeroHeader(availableFulfillmentMethods);

  const theme = useTheme();

  React.useEffect(() => {
    if (cart.shipping_google_place_id) {
      dispatch(getDeliverableLocations());
    }
  }, []);
  return (
    /**
     * render the hero image only when locations are available as well
     */
    <BaseLayout
      heroSrc={heroImageSrc}
      heroAlt={heroImageAlt}
      heroContent={
        <DarkCover
          dataTestId="dark-cover"
          background={heroImageSrc ? '' : theme.palette.secondary.main}
        >
          {googleLoaded && (
            <LocationListHeroContent
              heading={heroHeader}
              handleSelect={handleAddressSelect}
              address={getAddressStringFromCart(cart)}
              showAddressAutoComplete={!isDineInVariant}
            />
          )}
        </DarkCover>
      }
    >
      {children}
    </BaseLayout>
  );
};

LocationListOuterLayout.propTypes = {
  children: PropTypes.object,
  heroImageSrc: PropTypes.string,
  heroImageAlt: PropTypes.string,
  availableFulfillmentMethods: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_FULFILLMENT_METHODS)
  ),
  dispatch: PropTypes.func.isRequired,
  googleLoaded: PropTypes.bool,
  cart: PropTypes.shape({ shipping_google_place_id: PropTypes.string })
};

const mapStateToProps = state => {
  const heroImage = get(
    state.account,
    'online_ordering_general_settings.store_header_image[0]',
    {}
  );
  const availableFulfillmentMethods = getAllLocationsAvailableFulfillmentMethodSelector(
    state.restaurantLocations,
    state.locationThrottledTimes,
    state.cart
  );

  const googleLoaded = state.libraryLoad.google;
  return {
    heroImageSrc: heroImage.url,
    heroImageAlt: heroImage.alt,
    availableFulfillmentMethods,
    googleLoaded,
    cart: state.cart
  };
};

export default connect(mapStateToProps)(React.memo(LocationListOuterLayout));
